<template>
    <QDialog
        v-model="opened"
        @hide="close"
    >
        <QCard class="flex column Card">
            <QBar class="bg-primary text-white">
                <div class="text-subtitle1 text-weight-medium">
                    {{ $t('visualization.bpmnModal.title') }}
                </div>
                <QSpace />
                <QBtn
                    v-close-popup
                    dense
                    flat
                    color="white"
                    icon="close"
                    @click="close"
                />
            </QBar>
            <q-card-section class="q-pt-none q-px-lg Body">
                <QForm
                    class="align-center q-gutter-md q-ma-md"
                    @submit="handleSaveModel"
                >
                    <QInput
                        ref="name"
                        v-model="modelName"
                        :label="$t('visualization.bpmnModal.name')"
                        outlined
                        stackLabel
                        dense
                        :rules="[val => !!val || 'Field is required']"
                    />
                    <QBtn
                        :label="$t('visualization.bpmnModal.submit')"
                        noCaps
                        color="primary"
                        outline
                        type="submit"
                    />
                </QForm>
            </q-card-section>
        </QCard>
    </QDialog>
</template>

<script>

export default {
    name: 'CreateComponentModel',
    components: {},
    emits: [
        'save',
    ],
    data() {
        return {
            opened: false,
            modelName: undefined,
        }
    },
    computed: {
    },
    methods: {
        open() {
            this.reset()
            this.opened = true
        },
        close() {
            this.opened = false
        },
        reset() {
            this.modelName = undefined
            this.file = undefined
        },
        handleSaveModel() {
            if (this.$refs.name.validate()) {
                this.$emit('save', {
                    modelName: this.modelName,
                })
            }
        },
    },
}
</script>
<style scoped lang="scss">
.Card .Body {
    min-width: 500px
}
.Header {
    padding-bottom:0px;
}
</style>
